export default "__VITE_PUBLIC_ASSET__c88293d8__"